
import BlockText from '../implementations/Block/Text';
import BlockCallToAction from '../implementations/Block/CallToAction';

const mappers = {
  text: BlockText,
  call_to_action: BlockCallToAction,
};

export default mappers;

